// extracted by mini-css-extract-plugin
export default {"lntFormGroup":"styles_lnt-form-group__5zVe7"};